// import React from "react";
// import { useTranslation } from "react-i18next"; // or your custom hook if you have one
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Typography,
//   Card,
// } from "@mui/material";

// type PriceLadderStep = {
//   minQuantity: number;
//   maxQuantity: number;
//   pricePerPhoto: number;
// };

// const PriceLadderDisplay = ({
//   pricingLadder,
// }: {
//   pricingLadder: PriceLadderStep[] | undefined;
// }) => {
//   const { t } = useTranslation();

//   return (
//     <div>
//       {pricingLadder && pricingLadder.length > 0 && (
//         <>
//           <TableContainer component={Paper} sx={{ marginBottom: "8px" }}>
//             <Table size="small">
//               <TableHead>
//                 <TableRow>
//                   <TableCell>{t("minQuantity")}</TableCell>
//                   <TableCell>{t("maxQuantity")}</TableCell>
//                   <TableCell>{t("pricePerPhoto")}</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {pricingLadder.map((ladderStep, index) => (
//                   <TableRow key={index}>
//                     <TableCell>{ladderStep.minQuantity}</TableCell>
//                     <TableCell>{ladderStep.maxQuantity}</TableCell>
//                     <TableCell>
//                       {(ladderStep.pricePerPhoto / 100).toFixed(2)}€
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </>
//       )}
//     </div>
//   );
// };

// export default PriceLadderDisplay;

"use client";

import React from "react";
import { useAppTranslate } from "src/hooks/useAppTranslate";
import {
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
  Paper,
  Box,
  Button,
} from "@mui/material";
import { getCurrencyBasedOnDomain } from "src/utils/domain.util";
import { formatCurrency } from "@configs/currencies";

type PriceLadderStep = {
  minQuantity: number;
  maxQuantity: number;
  pricePerPhoto: number;
};

const PriceLadderDisplay = ({
  default: defaultPrice,
  pricingLadder,
  currency,
}: {
  default: number;
  pricingLadder: PriceLadderStep[] | undefined;
  currency: string;
}) => {
  const t = useAppTranslate();
  const [showPriceLadder, setShowPriceLadder] = React.useState(false);
  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Button type="button" onClick={() => setShowPriceLadder(!showPriceLadder)}>
          {t("photoSize.pricingLadder.showHide")}
        </Button>
      </Box>
      {showPriceLadder && (
        <Paper elevation={3} sx={{ margin: "auto", marginBottom: "8px" }}>
          {/* Adjust the maxWidth to fit your design */}
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            p={"0"}
          >
            {pricingLadder && pricingLadder.length > 0 ? (
              <>
                {/* <Typography variant="h6" component="h3" gutterBottom>
              {t("priceLadder")}
            </Typography> */}
                <List dense>
                  {pricingLadder.map((ladderStep, index) => (
                    <React.Fragment key={index}>
                      {index > 0 && <Divider component="li" />}
                      <ListItem>
                        <ListItemText
                          primary={`${t("photoSize.pricingLadder.from")} ${
                            ladderStep.minQuantity
                          } ${t("photoSize.pricingLadder.to")} ${
                            ladderStep.maxQuantity
                          } ${t(
                            "photoSize.pricingLadder.photos"
                          )}: ${formatCurrency(
                            ladderStep.pricePerPhoto / 100,
                            currency
                          )}`}
                          primaryTypographyProps={{ textAlign: "center" }} // This will center the text inside ListItemText
                        />
                      </ListItem>
                    </React.Fragment>
                  ))}
                  <React.Fragment key={pricingLadder.length}>
                    <Divider component="li" />
                    <ListItem>
                      <ListItemText
                        primary={`${t("photoSize.pricingLadder.from")} ${
                          pricingLadder[pricingLadder.length - 1].maxQuantity
                        } ${t("photoSize.pricingLadder.to")} ∞ ${t(
                          "photoSize.pricingLadder.photos"
                        )}: ${formatCurrency(defaultPrice / 100, currency)}`}
                        primaryTypographyProps={{ textAlign: "center" }} // This will center the text inside ListItemText
                      />
                    </ListItem>
                  </React.Fragment>
                </List>
              </>
            ) : (
              <List dense>
                <React.Fragment key={0}>
                  <Divider component="li" />
                  <ListItem>
                    <ListItemText
                      primary={`${t("photoSize.pricingLadder.pricePerPhoto")}: 
                        ${formatCurrency(defaultPrice / 100, currency)}`}
                      primaryTypographyProps={{ textAlign: "center" }} // This will center the text inside ListItemText
                    />
                  </ListItem>
                </React.Fragment>
              </List>
            )}
          </Box>
        </Paper>
      )}
    </>
  );
};

export default PriceLadderDisplay;
